window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages.Safra = window.FazendaRP.Pages.Safra || {};

window.FazendaRP.Pages.Safra.Contratos = {
    init: async function () {
        const container = document.getElementById('view-contratos');
        if (!container) return;

        container.innerHTML = `
            <div style="display: flex; justify-content: flex-end; margin-bottom: 20px;">
                <button class="btn btn-primary" onclick="window.FazendaRP.Pages.Safra.Contratos.openModal()"><i class="fas fa-plus"></i> Novo Contrato</button>
            </div>
            <div id="contratos-list" class="loading-state"><i class="fas fa-spinner fa-spin"></i> Carregando contratos...</div>
        `;

        await this.loadContratos();
    },

    loadContratos: async function () {
        const listEl = document.getElementById('contratos-list');

        // 1. Fetch Contratos
        const { data: contratos, error } = await window.FazendaRP.supabase
            .from('safras_contratos')
            .select('*, parceiros(nome)')
            .order('created_at', { ascending: false });

        if (error) {
            listEl.innerHTML = `<p style="color:red">Erro ao carregar contratos: ${error.message}</p>`;
            return;
        }

        if (!contratos || contratos.length === 0) {
            listEl.innerHTML = `<div style="text-align:center; padding:40px; color:#64748b;">Nenhum contrato cadastrado.</div>`;
            return;
        }

        // 2. Fetch Deliveries (Romaneios linked to Contracts)
        // Optimization: Fetch all deliveries that have a contrato_id in one go
        const contractIds = contratos.map(c => c.id);
        const { data: entregas, error: errEntregas } = await window.FazendaRP.supabase
            .from('safras_colheitas')
            .select('contrato_id, peso_liquido_final')
            .in('contrato_id', contractIds);

        // Map Deliveries to Contracts
        const deliveriesMap = {};
        if (entregas) {
            entregas.forEach(e => {
                if (!deliveriesMap[e.contrato_id]) deliveriesMap[e.contrato_id] = 0;
                deliveriesMap[e.contrato_id] += e.peso_liquido_final || 0;
            });
        }

        // Render Cards
        let html = '';
        for (const c of contratos) {
            const delivered = deliveriesMap[c.id] || 0;
            const total = c.quantidade_kg || 0;
            const percent = total > 0 ? Math.min(100, (delivered / total) * 100) : 0;
            const remaining = Math.max(0, total - delivered);

            // Converter kg para sc for display (if needed, usually 60kg)
            const totalSc = (total / 60).toLocaleString('pt-BR', { maximumFractionDigits: 0 });
            const deliveredSc = (delivered / 60).toLocaleString('pt-BR', { maximumFractionDigits: 0 });
            const remainingSc = (remaining / 60).toLocaleString('pt-BR', { maximumFractionDigits: 0 });

            let statusColor = '#dbeafe'; // Blue
            let statusTextColor = '#1e40af';
            let statusLabel = c.status;

            // Auto-update status visual if fulfilled
            if (remaining <= 0 && c.status === 'Aberto') {
                statusLabel = 'Cumprido (Auto)';
                statusColor = '#dcfce7';
                statusTextColor = '#166534';
            }
            if (c.status === 'Cumprido') { statusColor = '#dcfce7'; statusTextColor = '#166534'; }
            if (c.status === 'Cancelado') { statusColor = '#fee2e2'; statusTextColor = '#991b1b'; }

            html += `
            <div class="card">
                <div style="display:flex; justify-content:space-between; margin-bottom:10px;">
                    <div>
                        <h4 style="margin:0; font-size: 1.1rem; color:#1e293b;">${c.numero_contrato} <span style="font-weight:400; color:#64748b;">| ${c.parceiros?.nome || 'Cliente Desconhecido'}</span></h4>
                        <p style="margin:5px 0 0; font-size:0.9rem; color:#64748b;">
                            ${c.tipo} • ${parseFloat(c.valor_unitario || 0).toLocaleString('pt-BR', { style: 'currency', currency: c.moeda })} / sc
                        </p>
                    </div>
                    <div style="text-align:right;">
                        <span style="background:${statusColor}; color:${statusTextColor}; padding:4px 10px; border-radius:15px; font-size:0.8rem; font-weight:600;">${statusLabel}</span>
                    </div>
                </div>
                
                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 20px; align-items:center; margin-top:15px;">
                    <div>
                        <div style="font-size:0.8rem; color:#64748b;">Volume Contratado</div>
                        <div style="font-size:1.2rem; font-weight:700;">${totalSc} sc <span style="font-size:0.9rem; color:#94a3b8;">(${(total / 1000).toFixed(1)} ton)</span></div>
                    </div>
                    <div>
                        <div style="font-size:0.8rem; color:#64748b;">Entregue</div>
                        <div style="font-size:1.2rem; font-weight:700; color:#15803d;">${deliveredSc} sc</div>
                    </div>
                    <div>
                        <div style="font-size:0.8rem; color:#64748b;">Falta Entregar</div>
                        <div style="font-size:1.2rem; font-weight:700; color:#f59e0b;">${remainingSc} sc</div>
                    </div>
                </div>

                <div class="progress-container">
                    <div class="progress-bar" style="width: ${percent}%;"></div>
                </div>
                <div style="text-align:right; font-size:0.8rem; color:#64748b; margin-top:4px;">${percent.toFixed(1)}% Completo</div>
            </div>`;
        }
        listEl.innerHTML = html;
    },

    openModal: async function () {
        // 1. Fetch Partners first to ensure readiness
        const partners = await this.getParceiros();
        if (partners.length === 0) {
            alert("Cadastre parceiros (Clientes) primeiro no módulo financeiro.");
            return;
        }

        // 2. Create Modal
        const modalId = 'modal-novo-contrato';
        let modal = document.getElementById(modalId);
        if (modal) modal.remove(); // Reset if exists

        modal = document.createElement('div');
        modal.id = modalId;
        modal.className = 'modal-overlay';
        modal.innerHTML = `
            <div class="modal-content" style="max-width: 600px;">
                <div class="modal-header">
                    <h3><i class="fas fa-file-signature"></i> Novo Contrato de Venda</h3>
                    <button class="close-modal" onclick="document.getElementById('${modalId}').remove()">&times;</button>
                </div>
                <div class="modal-body">
                    <form id="form-contrato" onsubmit="event.preventDefault(); window.FazendaRP.Pages.Safra.Contratos.saveContrato()">
                        <div class="form-grid">
                            <div class="form-group">
                                <label>Número do Contrato</label>
                                <input type="text" id="c-numero" class="form-control" placeholder="Ex: CTR-2024-001" required>
                            </div>
                            <div class="form-group">
                                <label>Data Contrato</label>
                                <input type="date" id="c-data" class="form-control" required>
                            </div>
                        </div>

                        <div class="form-group" style="margin-top:15px;">
                            <label>Comprador (Cliente)</label>
                            <select id="c-parceiro" class="form-control" required>
                                <option value="">Selecione...</option>
                                ${partners.map(p => `<option value="${p.id}">${p.nome}</option>`).join('')}
                            </select>
                        </div>

                        <div class="form-grid" style="margin-top:15px;">
                            <div class="form-group">
                                <label>Quantidade (Sacas)</label>
                                <input type="number" id="c-qtd-sc" class="form-control" placeholder="0" step="0.01" oninput="window.FazendaRP.Pages.Safra.Contratos.updateKgPreview()" required>
                                <small style="color:#64748b" id="preview-kg">= 0 kg</small>
                            </div>
                            <div class="form-group">
                                <label>Valor Unitário (Por Saca)</label>
                                <input type="number" id="c-valor" class="form-control" placeholder="0.00" step="0.01" required>
                            </div>
                        </div>

                        <div class="form-grid" style="margin-top:15px;">
                            <div class="form-group">
                                <label>Moeda</label>
                                <select id="c-moeda" class="form-control">
                                    <option value="BRL">BRL (R$)</option>
                                    <option value="USD">USD ($)</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Tipo</label>
                                <select id="c-tipo" class="form-control">
                                    <option value="Futuro">Venda Futura</option>
                                    <option value="Spot">Spot (Imediato)</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group" style="margin-top:15px;">
                            <label>Safra</label>
                            <select id="c-safra-id" class="form-control">
                                <option value="1">Safra 2024/25</option>
                                <!-- TODO: Load from Safras table -->
                            </select>
                        </div>

                        <div style="margin-top: 25px; text-align: right; border-top: 1px solid #f1f5f9; padding-top: 20px;">
                            <button type="button" class="btn btn-secondary" onclick="document.getElementById('${modalId}').remove()">Cancelar</button>
                            <button type="submit" class="btn btn-primary">Criar Contrato</button>
                        </div>
                    </form>
                </div>
            </div>
        `;
        document.body.appendChild(modal);

        // Set Today
        document.getElementById('c-data').value = new Date().toISOString().split('T')[0];
    },

    updateKgPreview: function () {
        const sc = parseFloat(document.getElementById('c-qtd-sc').value) || 0;
        const kg = sc * 60;
        document.getElementById('preview-kg').innerText = `= ${kg.toLocaleString('pt-BR')} kg`;
    },

    saveContrato: async function () {
        const payload = {
            safra_id: document.getElementById('c-safra-id').value,
            parceiro_id: document.getElementById('c-parceiro').value,
            numero_contrato: document.getElementById('c-numero').value,
            data_contrato: document.getElementById('c-data').value,
            quantidade_kg: (parseFloat(document.getElementById('c-qtd-sc').value) || 0) * 60,
            valor_unitario: parseFloat(document.getElementById('c-valor').value),
            moeda: document.getElementById('c-moeda').value,
            tipo: document.getElementById('c-tipo').value,
            status: 'Aberto'
        };

        const { error } = await window.FazendaRP.supabase
            .from('safras_contratos')
            .insert([payload]);

        if (error) {
            alert("Erro ao criar contrato: " + error.message);
        } else {
            alert("Contrato criado com sucesso!");
            document.getElementById('modal-novo-contrato').remove();
            this.loadContratos(); // Refresh List

            // Also refresh Dashboard if open, as it depends on Contracts for 'Destino' charts sometimes or totals
            if (window.FazendaRP.Pages.Safra.Dashboard) window.FazendaRP.Pages.Safra.Dashboard.loadMetrics();
        }
    },

    getParceiros: async function () {
        const { data } = await window.FazendaRP.supabase.from('parceiros').select('id, nome').order('nome');
        return data || [];
    }
};
